import React from "react";
import { railStatus, statusColor } from "@/lib/railStatus";

/**
 * Small status pill — used in PnrCard passenger rows and the filter rail.
 * Renders the raw IRCTC status string with a status-colored dot, bg tint
 * and border, monospace, and the appropriate emerald / amber / rose / zinc
 * palette per railStatus().
 */
const StatusPill = ({ status, withDot = true, className = "" }) => {
  const c = statusColor[railStatus(status)];
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-[11px] font-medium font-mono border ${c.text} ${c.bg} ${c.border} ${className}`}
    >
      {withDot && <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />}
      {status}
    </span>
  );
};

export default StatusPill;
